module.exports = __webpack_public_path__ + "static/media/refresh.706b247f.PNG";